<template>
  <div
    class="tw-w-full tw-h-48 tw-rounded-md tw-bg-primary-grey-50 tw-border-dashed tw-border-primary-grey-100 tw-border-2 tw-p-4 tw-flex tw-flex-col tw-justify-center tw-items-center tw-transition-colors"
  >
    <div class="tw-relative tw-stroke-primary-grey-200 tw-mb-1">
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.1739 28.416C9.09438 28.416 7.10001 27.6258 5.62956 26.2193C4.1591 24.8128 3.33301 22.9051 3.33301 20.916C3.33301 18.9269 4.1591 17.0192 5.62956 15.6127C7.10001 14.2062 9.09438 13.416 11.1739 13.416C11.6651 11.228 13.1019 9.30515 15.1682 8.07054C16.1914 7.45922 17.3383 7.03526 18.5435 6.82287C19.7488 6.61048 20.9887 6.61381 22.1924 6.83268C23.3962 7.05155 24.5403 7.48167 25.5594 8.09848C26.5785 8.71529 27.4526 9.50671 28.1319 10.4276C28.8111 11.3484 29.2822 12.3806 29.5182 13.4653C29.7541 14.55 29.7504 15.6659 29.5073 16.7493H31.1739C32.721 16.7493 34.2047 17.3639 35.2987 18.4579C36.3927 19.5519 37.0073 21.0356 37.0073 22.5827C37.0073 24.1298 36.3927 25.6135 35.2987 26.7075C34.2047 27.8014 32.721 28.416 31.1739 28.416H29.5073M14.5072 23.416L19.5072 18.416M19.5072 18.416L24.5072 23.416M19.5072 18.416V33.416"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="tw-relative tw-text-primary-grey-200 tw-font-bold">
      {{ $t("add-logo") }}
    </div>
    <div class="tw-relative tw-text-primary-grey-200 tw-font-normal">
      {{ $t("logo-file-guidelines") }}
    </div>
  </div>
</template>
